import { render } from "./MyWallet.vue?vue&type=template&id=386caa42&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"

import "./MyWallet.vue?vue&type=style&index=0&id=386caa42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386caa42"]])

export default __exports__